import React from 'react';
import { Box, IconButton, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Typography } from '@mui/material';
import { capitalize } from 'lodash';
import ZoneThumbnail from '@components/common/ZoneThumbnail';
import { Cancel, CheckCircle } from '@mui/icons-material';

type ZoneSuggestionListItemProps = {
  zone: Zone,
  index: number,
  onZoneMouseEnter?: (zoneId: string) => void;
  onZoneMouseLeave?: (zoneId: string) => void;
  onAcceptSuggestion: () => void;
  onDeclineSuggestion: () => void;
}

const ZoneSuggestionListItem: React.FC<ZoneSuggestionListItemProps> = (props) => {
  const { zone, index, onZoneMouseEnter, onZoneMouseLeave, onAcceptSuggestion, onDeclineSuggestion } = props;

  return (
    <>
      <ListItem
        onMouseEnter={() => { if (onZoneMouseEnter) onZoneMouseEnter(zone.id) }}
        onMouseLeave={() => { if (onZoneMouseLeave) onZoneMouseLeave(zone.id) }}
        disableGutters={true}
        button
      >
        <ListItemAvatar>
          <ZoneThumbnail zone={zone} />
        </ListItemAvatar>
        <ListItemText
          primary={zone.name || `Zone ${index}`}
          secondary={
            <React.Fragment>
              <Typography style={{ display: 'inline' }} color="textPrimary" component="span" variant="body2">{`${capitalize(zone.state)}`}</Typography>
              {zone.description !== undefined && zone.description !== "" &&
                ` — ${zone.description}`
              }
            </React.Fragment>
          }
        />
        <ListItemSecondaryAction>
          <Box>
            <IconButton onClick={onAcceptSuggestion} style={{ marginLeft: '0.5rem' }}>
              <CheckCircle color="primary" />
            </IconButton>
            <IconButton onClick={onDeclineSuggestion} style={{ marginLeft: '0.5rem' }}>
              <Cancel color="error" />
            </IconButton>
          </Box>
        </ListItemSecondaryAction>
      </ListItem>
    </>
  )
}

export default ZoneSuggestionListItem;
